<script>
  export let open = null 
  export let userid = null
  import {onMount,onDestroy} from "svelte"
  import {load,save} from "../shared/api.js"
  import Modal from "../shared/modal.svelte"
  import Formrow from "../shared/formrow.svelte"
  import Button from "../shared/button.svelte"

  let username = ""
  let password = ""
  let loginForm

  function show(){
    open = true
  }

  function hide(){
    open = null
  }

  const login = async ()=>{
    if(loginForm && loginForm.reportValidity && !loginForm.reportValidity()){// show errors if browser supports this
      return // don't submit if invalid
    }
    let user = (await save({ url:"/duocms/api/login", data:{username,password}})).data
    if(user && user.id){
      userid = user.id
      hide()
      setTimeout(()=>{
        window.location.reload()
      },500)
    }
  }
</script>

<style>
  /*hide submit*/
  input[type=submit]{
    line-height:0;
    height:0;
    overflow:hidden;
    padding:0;
    border:0;
  }

</style>

<Modal heading="Sign In" open={open} on:closed={hide} style="width:400px">
  <form on:submit={login} bind:this={loginForm}>
    <Formrow label="Email" type="email" name="email" bind:value={username} required autocomplete="email" labelwidth="100px" />
    <Formrow label="Password" type="password" name="password" bind:value={password} required autocomplete="password" labelwidth="100px" />
    <input type="submit">
  </form>
  <div slot="toolbar">
    <div style="float:right">
      <Button mode="default" on:click={hide}>Close</Button>
      <Button mode="primary" on:click={login}>Login</Button>
    </div>
  </div>
</Modal>